import AllPages from "./routes";
import "./App.scss";

function App() {
  return (
    <div className="App">
        <AllPages />
    </div>
  );
}

export default App;
